var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconKakao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_kakao"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 32758"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0577 1C4.50538 1 0 4.4875 0 8.7625C0 11.4625 1.84685 13.825 4.50537 15.2875L3.81134 19L8.09321 16.3C8.66961 16.4125 9.36365 16.4125 9.94006 16.4125C15.4924 16.4125 19.9977 12.925 19.9977 8.65C20.1154 4.4875 15.61 1 10.0577 1Z",
    fill: "var(--fill-0, #1E1E1E)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKakao);
export default __webpack_public_path__ + "static/media/icon-kakao.6aef944e90a19c36333742ed7d9a95ff.svg";
export { ForwardRef as ReactComponent };